import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import {FeatureFlags, FeatureFlagService } from 'src/app/services/feature-flag.service';

@Directive({
  selector: '[ifFeatureEnabled]',
  standalone: true,
})
export class IfFeatureEnabledDirective implements OnInit {

  @Input('ifFeatureEnabled') feature: FeatureFlags = FeatureFlags.Default;

  constructor(private el: ElementRef, private featureFlagService: FeatureFlagService) { }

  ngOnInit(): void {
    if(!this.featureFlagService.featureEnabled(this.feature)){
      this.el.nativeElement.parentNode.removeChild(this.el.nativeElement);
    }
  }
}

@Directive({
  selector: '[ifFeatureDisabled]',
  standalone: true,
})
export class IfFeatureDisabledDirective implements OnInit {

  @Input('ifFeatureDisabled') feature: FeatureFlags = FeatureFlags.Default;

  constructor(private el: ElementRef, private featureFlagService: FeatureFlagService) { }

  ngOnInit(): void {
    if(this.featureFlagService.featureEnabled(this.feature)){
      this.el.nativeElement.parentNode.removeChild(this.el.nativeElement);
    }
  }
}
